
class RelatedItemsAvailability extends HTMLElement {

    constructor() {
        super();
        this.allRelatedItems = this.getAllItems();
        this.getAllProductData();
        this.quickAddDrawer = document.querySelector('quick-add-drawer');
        this.setupMutationObserver();
    }

    getAllItems() {
        return this.querySelectorAll('.product-metafield-list a').length > 0 ? this.querySelectorAll('.product-metafield-list a'): null;
    }

    getAllProductData() {
        let allProd = this.getAllItems();
            console.log("allProd",allProd);
        allProd.forEach(prod_handle => {
            let fullProdURL = prod_handle.getAttribute('data-href');
            this.getProdAndAction(prod_handle, fullProdURL);
        })
    }

    getProdAndAction(prodNode, handle) {
        // You can fetch data or perform actions related to each product URL here
        fetch(handle+'.json')
            .then(response => {
                if (response.ok) {
                    return response.text();
                }
                throw new Error('Network response was not ok.');
            })
            .then(data => {
                // Process the HTML response as needed
                prodNode.classList.remove('hidden');
                prodNode.setAttribute('href', handle);
                let imageSrc = prodNode.querySelector('.metafield-product-image').getAttribute('data-image-src');
                let imageTag = prodNode.querySelector('.metafield-product-image img');
                imageTag.setAttribute('src', imageSrc);               
            })
            .catch(error => {
                console.error('Error fetching product data:', error);
            });
    }

    setupMutationObserver() {
        const observer = new MutationObserver(mutationsList => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
                    if (mutation.target.getAttribute('aria-hidden') === 'true') {
                        // Reinitialize component when quickAddDrawer is open
                        this.getAllProductData();
                    }
                }
            }
        });

        observer.observe(this.quickAddDrawer, { attributes: true });
    }
    


}

customElements.define('related-items-availability', RelatedItemsAvailability);
  